const maintenanceCountDownCopy = {
  message: 'Maintenance will start in:'
};

export default maintenanceCountDownCopy;
